export const STICKER_LOCATION_INSIDE = 'inside';
export const STICKER_LOCATION_OUTSIDE = 'outside';

export const STICKER_LOCATION_KEY = 'location';

export const STICKER_LOCATIONS = [STICKER_LOCATION_INSIDE, STICKER_LOCATION_OUTSIDE] as const;

export type StickerLocation = (typeof STICKER_LOCATIONS)[number];

export function isStickerLocation(value?: string | null): value is StickerLocation {
	const locations: string[] = [...STICKER_LOCATIONS];
	return typeof value === 'string' && locations.includes(value);
}

export function parseStickerLocation(data: FormData): StickerLocation {
	const result = data.get(STICKER_LOCATION_KEY)?.toString() ?? null;
	return isStickerLocation(result) ? result : STICKER_LOCATION_OUTSIDE;
}

export function getStickerLocationName(location: StickerLocation) {
	return location === STICKER_LOCATION_INSIDE ? 'Innsiden (speilvendt)' : 'Utsiden (vanlig)';
}
